module.exports = __webpack_public_path__ + "static/media/rugDamaged.46347f27.png";